<template>
  <m-container :layout="layout" :class="{ 'initial:gap-4': $slots.default }">
    <m-icon class="text-accent" :icon="faSpinner" :spin="true" :size="size" />
    <slot></slot>
  </m-container>
</template>

<script lang="ts" setup>
  import { faSpinner } from '@fortawesome/free-solid-svg-icons';
  import type { MIconProps } from '../MIcon';
  import type { MContainerProps } from '../MContainer/MContainer.vue';
  import MContainer from '../MContainer/MContainer.vue';
  import MIcon from '../MIcon/MIcon.vue';

  withDefaults(defineProps<Pick<MIconProps, 'size'> & MContainerProps>(), {
    size: '5x',
  });
</script>
